export const RECIPE_NAME_LABEL = 'Recipe Name';
export const RECIPE_NAME_PLACEHOLDER = 'Select A Name';
